<template>
  <div class="home">
    <div class="banner">
      <img alt="Vue logo" style="width: 64px; height: 64px" src="../assets/logo.png">
      <h1 style="margin-top: 1rem;font-size: 50px">欢迎进入挑选好医生管理系统</h1>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Index',
  components: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.home {
  width: 900px;
  margin: 0 auto;
  padding: 25px 0;
}

.home > .banner {
  text-align: center;
  padding: 25px 0;
  margin: 25px 0;
}
</style>
